import React from 'react';
import AliceCarousel from 'react-alice-carousel';
import Store from 'store';
import { BannerItem, BoxInImage } from '../HomePage';
import { useHomeBanner } from '../../hooks/useHomeBanner';
import { getCurrentLang } from '../../libs/lang';
import { useHomePageContext } from '../../context/HomePageContext';
import { S3_URL } from '../../libs/common';

export const HomeBanner1 = () => {
  const { state, actions } = useHomeBanner();
  const { state: home_state, actions: home_actions, responsiveConfig } = useHomePageContext();
  const mainCarouselRef = React.useRef(null);

  const indicatorStyles = {
    height: 8,
    display: 'inline-block',
    margin: '0 8px',
    cursor: 'pointer',
    zIndex: 99,
  };

  /** ✅ 점 클릭 */
  const handleDotClick = (index) => {
    if (mainCarouselRef.current) {
      mainCarouselRef.current.slideTo(index);
    }
  };

  /** ✅ 언어별 리스트 매핑 */
  const bannerMap = {
    kr: home_state.data.mainBannerListKo,
    en: home_state.data.mainBannerListEn,
    jp: home_state.data.mainBannerListJp,
  };

  const currentLang = getCurrentLang();
  const bannerList = bannerMap[currentLang] || home_state.data.mainBannerListEn;

  /** ✅ Dot 렌더링 */
  const RenderDot = () =>
    Array(bannerList.length)
      .fill()
      .map((_, i) =>
        state.ui.mainBannerIndex === i ? (
          <div
            key={`dot-${i}`}
            style={{
              ...indicatorStyles,
              width: '4vw',
              borderRadius: 100,
              backgroundColor: 'rgba(256, 256, 256, 0.6)',
              backgroundSize: '4vw 8px',
            }}
          />
        ) : (
          <div
            key={`dot-${i}`}
            style={{
              ...indicatorStyles,
              width: 8,
              borderRadius: 100,
              backgroundColor: 'rgba(256, 256, 256, 0.6)',
              height: 8,
            }}
            onClick={() => handleDotClick(i)}
          />
        ),
      );

  return (
    <div style={{ position: 'relative' }}>
      <AliceCarousel
        ref={mainCarouselRef}
        autoPlay
        autoPlayInterval={4000}
        infinite
        disableButtonsControls
        disableDotsControls
        responsive={responsiveConfig.main}
        onInitialized={actions.handleMainSlideChange}
        onSlideChanged={actions.handleMainSlideChange}
        onResized={actions.handleMainSlideChange}
      >
        {bannerList.map((item, index) => (
          <BannerItem key={`main-${index}`} onClick={() => actions.goBannerUrl(item.banner_url, item.banner_event_id)}>
            <BoxInImage
              aria-label={item.banner_type}
              style={{
                backgroundImage: `url(${S3_URL(item.banner_img)})`,
              }}
            />
          </BannerItem>
        ))}
      </AliceCarousel>
      <div
        style={{
          position: 'absolute',
          bottom: '1vw',
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <RenderDot />
      </div>
    </div>
  );
};

export default HomeBanner1;
